import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { Card, Col, Row } from 'react-bootstrap';
import ManFlag from '../../../../../../images/man-flag.png';
import HEADER_TOOLBAR from '../HEADER_TOOLBAR';
import { t } from 'i18next';

class ELEMENT_KPI_FTE_CHART extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = {
      series: [{
        name: 'FTE',
        data: !this.props.inputParam_UseFake ? this.props.inputParam_ComponentContent.items.map(x => x.fte) : []
      }],
      options: {
        colors: [
          function ({ value, seriesIndex, dataPointIndex }) {
              if (value > 0) {
                return '#AEBCD9';
              }
              else {
                return '#5E7EBB';
              }
        }],
        chart: {
          type: 'bar',
          height: "100%"
        },
        plotOptions: {
          bar: {
            columnWidth: '80%',
          }
        },
        dataLabels: {
          enabled: false,
        },
        yaxis: {
          labels: {
            formatter: function (y) {
              return y.toFixed(0);
            }
          }
        },
        xaxis: {
          type: 'string',
          categories: !this.props.inputParam_UseFake ? this.props.inputParam_ComponentContent.items.map(x => x.periodId) : [],
          labels: {
            rotate: -90
          }
        }
      },
    };
  }

  renderContent() {
    return <Row className='h-100' style={{opacity: this.props.inputParam_UseFake ? ".4" : ""}}>
            <Col xl="10">
              <ReactApexChart options={this.state.options} series={this.state.series} type="bar" height="100%" />
            </Col>
            <Col xl="2" className='col-auto my-auto'>
              <Row>
                <Col className='text-center font-weight-bold' style={{fontSize: "42px"}}>128</Col>
              </Row>
              <Row>
                <Col className='text-center ms-3'>
                  <img src={ManFlag} style={{height: "80%"}} />
                </Col>
              </Row>
              <Row>
                <Col className='text-center font-weight-bold'>FTE</Col>
              </Row>
            </Col>
          </Row>
  }

  render() {
    return (
		<>
      {
        !this.props.inputParam_UseFake &&
        <Card className='h-100'>
          {
          !this.props.inputParam_HideHeader &&
          <Card.Header className="card-header-compact">
            <Card.Title className="d-flex justify-content-between">
              <b>{this.props.inputParam_ComponentContent !== null ? (this.props.inputParam_ComponentContent.boardComponentTitle ?? t('data-lang-boxname-fte')) : t('data-lang-boxname-fte')}</b>
              <div className='toolbar d-flex'>
                <HEADER_TOOLBAR
                  inputParam_BoardStructure={this.props.inputParam_BoardStructure}
                  inputParam_Container={this.props.inputParam_Container}
                />
              </div>
            </Card.Title>
          </Card.Header>
          }
          <Card.Body className='h-100'>
          { this.renderContent() }
          </Card.Body>
        </Card>
      }
      { this.props.inputParam_UseFake && this.renderContent() }
		</>
    );
  }
}

export default ELEMENT_KPI_FTE_CHART;